import toast from 'react-hot-toast';

import BaseButton from '../button/BaseButton';

interface Props {
  id: string;
  content: string;
  onMainButtonClick?: () => void;
}

function ToastBody({ id, content, onMainButtonClick }: Props) {
  return (
    <div className='flex w-full items-center justify-between rounded-[6px] bg-colorBg_snackbar px-[16px] py-[12px] text-colorFg05'>
      <div className='pr-3 text-[15px]'>
        <span className='break-all'>{content}</span>
      </div>
      {onMainButtonClick && id && (
        <div className='flex items-center'>
          <BaseButton
            type='button'
            variant='ghost'
            size='none'
            className='pl-[24px] text-center text-[16px] text-white'
            onClick={() => {
              onMainButtonClick();
              toast.dismiss(id);
            }}
          >
            {'확인'}
          </BaseButton>
        </div>
      )}
    </div>
  );
}

export default ToastBody;
